import {Component, Inject, OnInit, ViewChild,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  ControlItemsService, ProjectService, TenantService,
  UserService,
} from '../../_services/index';

import {ClientITProfile, NetworkDescriptionAndDiagram, Project, User} from '../../_models/index';

import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {MatStepper} from '@angular/material/stepper';


import {LoginHelper} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SelectControlItemComponent} from "../selectControlItem/select-control-item.component";
import {Constants} from "../../helpers/constants";

const defaultDialogConfig = new MatDialogConfig();

@Component({
    standalone: false,
  selector: "it-profile-template-edit-component",
  templateUrl: 'it-profile-template-edit.component.html',
  styleUrls: ['./it-profile-template-edit.component.scss'],
})

export class ItProfileTemplateEditComponent implements OnInit {
  public selectDialogRef: MatDialogRef<SelectControlItemComponent>;
  api: string = window.location.origin;
  tenantName: string = LoginHelper.getTenantName();
  quizForm: FormGroup;
  users: User[] = [];
  itProfiles: ClientITProfile[] = [];
  tenant: any;
  canCreateProfile = false;
  quiz: ClientITProfile = null;
  clientITProfileId: number;
  returnToProjectId: any = null;
  @ViewChild('stepper') stepper: MatStepper;
  cols: any[] = [
    {'field': 'category', 'header': 'Category'},
    {'field': 'complianceAreaControlId', 'header': 'Control ID'},
    {'field': 'description', 'header': 'Description'}
  ];
  projects : Project[] = null;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public controlItemsService: ControlItemsService,
    public userService: UserService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,
    public _formBuilder: FormBuilder,
    public projectsService: ProjectService,
    public tenantService: TenantService,
    public clientProfileService: ClientProfileService) {
  }

  ngOnInit() {
    this.tenantService.getCurrent().subscribe(t => {
      this.tenant = t;
      this.route.params.subscribe(p => {
        this.clientITProfileId = p['id'];
        this.loadItProfiles();
      });
      this.quizForm = this._formBuilder.group({
        deviceFieldNameDeviceName: ['Device Name', Validators.required],
        deviceFieldNameType: ['Type', Validators.required],
        deviceFieldNameManufacturer: ['Manufacturer', Validators.required],
        deviceFieldNameModel: ['Model', Validators.required],
        deviceFieldNameSerialNumber: ['Serial Number', Validators.required],
        deviceFieldNameIP: ['IP', Validators.required],
        deviceFieldNameMAC: ['MAC', Validators.required],
        deviceFieldNamePUID: ['PUID', Validators.required],
        deviceFieldNameOwner: ['Owner', Validators.required],
        deviceFieldNameLocation: ['Location', Validators.required],

        isDeviceNameVisible: [true],
        isTypeVisible: [true],
        isManufacturerVisible: [true],
        isModelVisible: [true],
        isSerialNumberVisible: [true],
        isIPVisible: [true],
        isMACVisible: [true],
        isPUIDVisible: [true],
        isOwnerVisible: [true],
        isLocationVisible: [true],

        name: ['', Validators.required],
        ownerList: [[]],
      });
    });

    this.projectsService.getAllShort().subscribe(p => {
      this.projects = p;
      if (this.quiz) {
        this.setReturnToProjectId();
      }
    });
  }

  send() {
    if (this.quizForm.valid) {
      this.quiz.quizData.steps.forEach(s => {
        s.items.forEach(i => {
          i.answers.forEach(a => {
            a.controlItemIds = a.controlItems.map(t => t.controlItemId);
          })
        })
      })
      this.quiz.ownerIds = (this.quizForm.value.ownerList || []).map(a => a.userId).join(',');
      this.quiz.quiz = JSON.stringify(this.quiz.quizData);
      this.clientProfileService.updateClientProfile({...this.quiz, ...this.quizForm.value}).subscribe((r) => {
        if (r.error) {
          this.alertService.error(r.error);
        }
        else
        {
          this.loadItProfiles();
          this.alertService.success("Successfully saved");
        }
      });
    } else {
      Object.keys(this.quizForm.controls).forEach(field => {
        const control = this.quizForm.get(field);
        control.markAsTouched({onlySelf: true});
      });
    }
  }

  onItProfileChanged(event) {
    this.router.navigate(['/profiles/itProfile', event.value, 'edit']);
  }

  createItProfile() {
    this.clientProfileService
      .updateClientProfile({name: 'IT Profile'})
      .subscribe((r) => this.router.navigate(['/profiles/itProfile', r.clientITProfileId, 'edit']));
  }

  loadItProfiles() {
    this.clientProfileService.getClientProfiles(this.tenantName).subscribe(t => {
      this.itProfiles = t;
      this.quiz = this.itProfiles.find(t => t.clientITProfileId == this.clientITProfileId);
      if (this.projects) {
        this.setReturnToProjectId();
      }
      this.canCreateProfile = this.tenantName == Constants.RiskSpongeMaster || this.itProfiles.length < this.tenant.maxProfiles;
      if (!this.quiz && this.itProfiles.length) {
        this.router.navigate(['/profiles', 'itProfile', this.itProfiles[0].clientITProfileId, 'edit']);
      } else {
        if (!this.clientITProfileId) {
          return;
        }
        this.userService.getAll().subscribe(u => {
          this.users = u;
          this.controlItemsService.getAll().subscribe(c => {
            const controlItems = c;

            this.quiz = this.quiz || {name: '', ownerIds: ''};

            this.quiz.quizData = this.quiz.quizData || {name: '', steps: [{name: "", items: []}]};
            this.quiz.quizData.steps = this.quiz.quizData.steps || [{name: "", items: []}];
            //this.stepper.selectedIndex = 10 + this.quiz.quizData.steps.length;

            let ownerList = ((this.quiz.ownerIds || '').split(',') || []).map(t => this.users.find(u => u.userId == parseInt(t))).filter(u => u);

            this.quizForm.setValue({
              name: this.quiz.name,
              ownerList: ownerList,
              deviceFieldNameDeviceName: this.quiz.deviceFieldNameDeviceName || 'Device Name',
              deviceFieldNameType: this.quiz.deviceFieldNameType || 'Type',
              deviceFieldNameManufacturer: this.quiz.deviceFieldNameManufacturer || 'Manufacturer',
              deviceFieldNameModel: this.quiz.deviceFieldNameModel || 'Model',
              deviceFieldNameSerialNumber: this.quiz.deviceFieldNameSerialNumber || 'Serial Number',
              deviceFieldNameIP: this.quiz.deviceFieldNameIP || 'IP',
              deviceFieldNameMAC: this.quiz.deviceFieldNameMAC || 'MAC',
              deviceFieldNamePUID: this.quiz.deviceFieldNamePUID || 'PUID',
              deviceFieldNameOwner: this.quiz.deviceFieldNameOwner || 'Owner',
              deviceFieldNameLocation: this.quiz.deviceFieldNameLocation || 'Location',

              isDeviceNameVisible: this.quiz.isDeviceNameVisible === null || this.quiz.isDeviceNameVisible === undefined ? true : this.quiz.isDeviceNameVisible,
              isTypeVisible: this.quiz.isTypeVisible === null || this.quiz.isTypeVisible === undefined ? true : this.quiz.isTypeVisible,
              isManufacturerVisible: this.quiz.isManufacturerVisible === null || this.quiz.isManufacturerVisible === undefined ? true : this.quiz.isManufacturerVisible,
              isModelVisible: this.quiz.isModelVisible === null || this.quiz.isModelVisible === undefined ? true : this.quiz.isModelVisible,
              isSerialNumberVisible: this.quiz.isSerialNumberVisible === null || this.quiz.isSerialNumberVisible === undefined ? true : this.quiz.isSerialNumberVisible,
              isIPVisible: this.quiz.isIPVisible === null || this.quiz.isIPVisible === undefined ? true : this.quiz.isIPVisible,
              isMACVisible: this.quiz.isMACVisible === null || this.quiz.isMACVisible === undefined ? true : this.quiz.isMACVisible,
              isPUIDVisible: this.quiz.isPUIDVisible === null || this.quiz.isPUIDVisible === undefined ? true : this.quiz.isPUIDVisible,
              isOwnerVisible: this.quiz.isOwnerVisible === null || this.quiz.isOwnerVisible === undefined ? true : this.quiz.isOwnerVisible,
              isLocationVisible: this.quiz.isLocationVisible === null || this.quiz.isLocationVisible === undefined ? true : this.quiz.isLocationVisible,
            });

            this.quiz.quizData.steps.forEach(s => {
              s.items.forEach(i => {
                i.answers.forEach(a => {
                  a.controlItems = controlItems.filter(t => (a.controlItemIds || []).find(d => d == t.controlItemId));
                })
              })
            });
          })
        })
      }
    });
  }

  copyItProfile(itProfile) {
    const quiz = JSON.parse(JSON.stringify(itProfile));
    quiz.name = "Copy of " + quiz.name;
    quiz.clientITProfileId = 0;
    (quiz.sensitivityCategorizations || []).forEach(c => {
      c.sensitivityCategorizationId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.controlOriginations || []).forEach(c => {
      c.controlOriginationId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.leveragedAuthorizations || []).forEach(c => {
      c.leveragedAuthorizationId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.portProtocolServices || []).forEach(c => {
      c.portProtocolServiceId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.standartAndGuidances || []).forEach(c => {
      c.standartAndGuidanceId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.lawAndRegulations || []).forEach(c => {
      c.lawAndRegulationId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.systemSecurityPlanApprovals || []).forEach(c => {
      c.systemSecurityPlanApprovalId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.networkDescriptionsAndDiagrams || []).forEach(c => {
      c.networkDescriptionAndDiagramId = 0;
    });
    (quiz.systemInterconnections || []).forEach(c => {
      c.systemInterconnectionId = 0;
    });
    (quiz.systemRolePrivileges || []).forEach(c => {
      c.systemRolePrivilegeId = 0;
    });
    (quiz.nameAndIdentifiers || []).forEach(c => {
      c.nameAndIdentifierId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.systemLocations || []).forEach(c => {
      c.systemLocationId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.devices || []).forEach(c => {
      c.deviceId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.otherDesignatedContacts || []).forEach(c => {
      c.otherDesignatedContactId = 0;
      c.clientITProfileId = 0;
    });
    (quiz.systemOwnerClientContact || {}).clientContactId = 0;
    quiz.systemOwnerClientContactId = 0;
    (quiz.securityPointClientContact || {}).clientContactId = 0;
    quiz.securityPointClientContactId = 0;
    (quiz.securityOfficerClientContact || {}).clientContactId = 0;
    quiz.securityOfficerClientContactId = 0;
    quiz.quiz = JSON.stringify(quiz.quizData);
    this.clientProfileService.updateClientProfile(quiz).subscribe(p => {
        this.router.navigate(['/profiles/itProfile', p.clientITProfileId, 'edit']);
        this.loadItProfiles();
      }
    );
  }

  addStep() {
    this.quiz.quizData.steps.push({name: '', items: []})
  }

  removeStep(i) {
    setTimeout(() => this.stepper.selectedIndex = 0, 500);
    setTimeout(() => this.quiz.quizData.steps.splice(i, 1), 500);
  }

  moveUp(list, i) {
    const s = list[i];
    list[i] = list[i - 1];
    list[i - 1] = s;
  }

  moveDown(list, i) {
    const s = list[i];
    list[i] = list[i + 1];
    list[i + 1] = s;
  }

  addQuestion(list) {
    list.push({type: 'question', name: '', answers: [], multiple: false});
  }

  addAnswer(list) {
    list.push({name: '', controlItems: []});
  }

  removeItProfile() {
    this.clientProfileService.removeClientProfiles(this.clientITProfileId).subscribe(t => {
      this.router.navigate(['/profiles/itProfile/edit']);
    });
  }

  addControlItem(list) {
    let config: MatDialogConfig = {
      width: "90%",
      height: "90%",
      data: {
        except: list || []
      }
    };

    this.selectDialogRef = this.dialog.open(SelectControlItemComponent, config);

    this.selectDialogRef.afterClosed().subscribe((data: any) => {
      if (data)
        list.push(data);
    });
  }

  removeControlItem(list, item) {
    list.splice(list.indexOf(item), 1);
  }

  stepClick(ev) {
    console.log(ev)
  }

  getFullName(user) {
    if (!user) {
      return '';
    }
    if (user.firstName != null
      || user.lastName != null) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress;
  }

  setReturnToProjectId(){
    var rememberedId = parseInt(window.localStorage.getItem('LastProjectVisited'));
    this.returnToProjectId = !isNaN(rememberedId) && rememberedId > 0 && this.projects.find(p => p.projectId == rememberedId) ? rememberedId : this.projects.find(p => p.clientITProfileIds && p.clientITProfileIds.split(';').map(i => parseInt(i)).indexOf(this.quiz?.clientITProfileId) >= 0)?.projectId || null;
  }
}
